import React from 'react';
import { ReferenceField, TextField } from 'react-admin';

export const AccountField = props =>
  <ReferenceField basePath="/accounts" resource="accounts" reference="accounts" link="show" {...props}>
    <TextField {...props} source="email" />
  </ReferenceField>
